import React, { Component } from "react";
import { Popover, Form, Button, Icon, Table, Modal, Input, Select, message } from "antd";
import {
	getFirstGroupList,
	getGroupsData,
	addFirstGroup,
	addSecondGroup,
	editGroup,
	updateGroupStatus
} from "@/request/api";
import "./settingUser.scss";
import {requestErrorLog } from '@/common/util'

const { TextArea } = Input;
const { Option } = Select;

class Grouping extends Component {
	constructor(props) {
		super(props);
		this.state = {
			tableList: [],
			PageNo: 1,
			PageSize: 10,
			RowCount: 0,
			groupName: "",
			groupData: [],
			firstGroupList: [],
			groupColumns: [
				{
					title: "关联编码",
					dataIndex: "GROUP_UID",
					key: "GROUP_UID",
					width: 300,
					ellipsis: true,
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: "300px" }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				},
				{
					title: "一级组别编码",
					dataIndex: "FIRST_GROUP_CODE",
					key: "FIRST_GROUP_CODE",
					width: 200,
					ellipsis: true,
					align: "center",
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: 200 }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				},
				{
					title: "一级组别名称",
					dataIndex: "FIRST_GROUP_NAME",
					key: "FIRST_GROUP_NAME",
					width: 200,
					ellipsis: true,
					align: "center",
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: 200 }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				},
				{
					title: "二级组别编码",
					dataIndex: "SECOND_GROUP_CODE",
					key: "SECOND_GROUP_CODE",
					width: 200,
					ellipsis: true,
					align: "center",
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: 200 }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				},
				{
					title: "二级组别名称",
					dataIndex: "SECOND_GROUP_NAME",
					key: "SECOND_GROUP_NAME",
					width: 200,
					ellipsis: true,
					align: "center",
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: 200 }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				},
				{
					title: "状态",
					dataIndex: "IS_ENABLED",
					key: "IS_ENABLED",
					width: 80,
					align: "center",
					render: (text) => {
						return !text ? <span>启用</span> : <span style={{ color: "red" }}>已停用</span>;
					}
				},
				{
					title: "备注",
					dataIndex: "REMARKS",
					key: "REMARKS",
					ellipsis: true,
					align: "center",
					render: (text) => {
						return (
							<Popover overlayStyle={{ width: "200px" }} content={<span style={{ color: "#333" }}>{text}</span>}>
								<span>{text}</span>
							</Popover>
						);
					}
				}
			]
		};
	}

	componentDidMount() {
		this.getGroupsList();
	}

	getGroupsList = async () => {
		let params = {
			GROUP_NAME: this.props.form.getFieldValue("groupName") || "",
			PageNo: this.state.PageNo,
			PageSize: this.state.PageSize
		};
		let res = await getGroupsData(params);
		if (res && res.Status === 1) {
			const dataList = res.Result;
			let RowCount = res.ResponseModel.RowCount;
			this.setState({
				tableList: dataList,
				RowCount
			});
		}else{
			requestErrorLog('', '权限管理-分组管理-获取分组列表报错', 0, true)
		}
	};

	getFirstGroupList = async () => {
		let res = await getFirstGroupList();
		if (res && res.Status === 1) {
			this.setState({
				firstGroupList: res.Result
			});
		}else{
			requestErrorLog('', '权限管理-分组管理-获取一级分组列表报错', 0, true)
		}
	};
	handleGroupAdd = () => {
		// 新增
		this.getFirstGroupList();
		this.setState({
			isModalVisible: true,
			modalTitle: "ADD",
			rowData: {}
		});
	};
	handleGroupEdit = () => {
		// 修改
		const { rowData } = this.state;
		if (rowData && rowData.GROUP_UID) {
			this.setState({
				isModalVisible: true,
				modalTitle: "EDIT"
			});
		} else {
			message.warning("请先选择要操作的数据");
		}
	};

	handleGroupSubmit = () => {
		const { modalTitle } = this.state;
		this.props.form.validateFields(async (err, values) => {
			if (!err) {
				if (modalTitle === "ADD") {
					this.addGroup(values);
				} else {
					this.editGroup(values);
				}
			}
		});
	};

	addGroup = async (values) => {
		if (values.groupType === 1) {
			let res = await addFirstGroup(values.typeName, values.remark);
			if (res && res.Status === 1) {
				if (res.Result === -2) {
					message.error("组别名称重复");
					return;
				}
				if (res.Result === -1) {
					message.error("添加失败，请稍后重试");
					return;
				}
			}else{
				requestErrorLog('', '权限管理-分组管理-增加一级分组报错', 0, true)
			}
		} else {
			let firstGroupName = this.state.firstGroupList.find(
				(item) => item.FIRST_GROUP_CODE === values.firstGroupCode
			).FIRST_GROUP_NAME;
			let res = await addSecondGroup({
				SECOND_GROUP_NAME: values.typeName,
				REMARKS: values.remark,
				FIRST_GROUP_CODE: values.firstGroupCode,
				FIRST_GROUP_NAME: firstGroupName
			});
			if (res && res.Status === 1) {
				if (res.Result === -3) {
					message.error("组别名称重复");
					return;
				}
				if (res.Result === -2) {
					message.error("一级组别不存在或不可用,请检查后重试");
					return;
				}
				if (res.Result === -1) {
					message.error("添加失败，请稍后重试");
					return;
				}
			}else{
				requestErrorLog('', '权限管理-分组管理-增加二级分组报错', 0, true)
			}
		}
		message.success("添加成功");
		this.handleCancel();
		this.handleGroupList();
	};

	editGroup = async (values) => {
		const { rowData } = this.state;
		let params = {
			GROUP_UID: rowData.GROUP_UID,
			FIRST_GROUP_CODE: rowData.FIRST_GROUP_CODE,
			FIRST_GROUP_NAME: values.firstGroupName,
			SECOND_GROUP_CODE: rowData.SECOND_GROUP_CODE,
			SECOND_GROUP_NAME: values.secondGroupName || null,
			REMARKS: values.remark
		};
		let res = await editGroup(params);
		if (res && res.Status === 1) {
			if (res.Result === -2) {
				message.error("一级组别名称重复");
				return;
			}
			if (res.Result === -3) {
				message.error("二级组别名称重复");
				return;
			}
			message.success("修改成功");
			this.handleCancel();
			this.changePageFn(this.state.PageNo);
		}else{
			requestErrorLog('', '权限管理-分组管理-编辑分组报错', 0, true)
		}
	};

	onClickRow = (record) => {
		return {
			onClick: () => {
				this.setState({
					rowData: record
				});
			}
		};
	};

	setRowClassName = (record) => {
		return record === this.state.rowData ? "clickRowStyl" : "";
	};

	handleCancel = () => {
		this.setState({
			isModalVisible: false
		});
		this.props.form.resetFields();
	};

	handleGroupList = () => {
		this.setState({ PageNo: 1, PageSize: 10 }, this.getGroupsList);
	};
	changeFocus = (e) => {
		if (e.keyCode === 13) {
			this.handleGroupList();
		}
	};
	changePageFn = (PageNo) => {
		this.setState({ PageNo }, this.getGroupsList);
	};

	changeEnabled = async () => {
		const { rowData } = this.state;
		if (!rowData) {
			message.warning("请先选择要操作的数据");
			return;
		}
		let { GROUP_UID, FIRST_GROUP_CODE, SECOND_GROUP_CODE, IS_ENABLED } = rowData;
		let params = {
			GROUP_UID,
			FIRST_GROUP_CODE,
			SECOND_GROUP_CODE,
			IS_ENABLED: Number(!IS_ENABLED)
		};
		let res = await updateGroupStatus(params);
		if (res && res.Status === 1) {
			message.success("修改成功");
			this.getGroupsList();
			this.setState({ rowData: "" });
		}else{
			requestErrorLog('', '权限管理-分组管理-修改分组报错', 0, true)
		}
	};
	//判断一级组别下拉框是否必选
	isFirstGroupRequired = () => {
		return this.props.form.getFieldValue("groupType") === 2;
	};
	render() {
		const { getFieldDecorator } = this.props.form;
		const { isModalVisible, modalTitle, groupColumns, tableList, rowData } = this.state;
		return (
			<div className="grouping">
				<div className="btnStyle" style={{ marginBottom: "10px" }}>
					<Button onClick={this.handleGroupAdd}>
						<Icon type="plus-circle" />
						添加
					</Button>
					<Button onClick={this.handleGroupEdit}>
						<Icon type="minus-circle" />
						修改
					</Button>
					{!rowData || !rowData.SECOND_GROUP_CODE ? null : !rowData?.IS_ENABLED ? (
						<Button onClick={this.changeEnabled} type="danger">
							<Icon type="close-circle" />
							停用
						</Button>
					) : (
						<Button onClick={this.changeEnabled}>
							<Icon type="check-circle" />
							启用
						</Button>
					)}
				</div>
				<Form layout="inline" className="searchBox">
					<Form.Item label="组别名称">
						{getFieldDecorator("groupName")(<Input allowClear onKeyUp={this.changeFocus} />)}
					</Form.Item>
					<Button onClick={this.handleGroupList}>查询</Button>
				</Form>
				<Table
					columns={groupColumns}
					dataSource={tableList}
					rowKey={(record) => record.GROUP_UID}
					pagination={{
						total: this.state.RowCount,
						current: this.state.PageNo,
						onChange: this.changePageFn
					}}
					onRow={this.onClickRow}
					rowClassName={this.setRowClassName}
				/>
				{isModalVisible ? (
					<Modal
						title={
							<div className="patient_title">
								<img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
								<span>{modalTitle === "ADD" ? "添加组别" : "编辑组别"}</span>
							</div>
						}
						visible={isModalVisible}
						maskClosable={false}
						onOk={this.handleGroupSubmit}
						onCancel={this.handleCancel}>
						<Form layout="inline">
							{modalTitle === "ADD" ? (
								<>
									<Form.Item label="组别类型" className="settingHospitalRequire">
										{getFieldDecorator("groupType", { initialValue: 1 })(
											<Select style={{ width: 200 }}>
												<Option value={1}>一级</Option>
												<Option value={2}>二级</Option>
											</Select>
										)}
									</Form.Item>
									<Form.Item label="组别名称" className="settingHospitalRequire">
										{getFieldDecorator("typeName", {
											rules: [{ required: true, message: "请输入组别名称" }]
										})(<Input placeholder="请输入组别名称" allowClear={true} maxLength={32} style={{ width: 200 }} />)}
									</Form.Item>
									<Form.Item label="一级组别" className="settingHospitalRequire">
										{getFieldDecorator("firstGroupCode", {
											rules: [
												{
													required: this.isFirstGroupRequired(),
													message: "请选择一级组别"
												}
											]
										})(
											<Select
												style={{ width: 200 }}
												showSearch
												placeholder="请选择一级组别"
												disabled={!this.isFirstGroupRequired()}
												optionFilterProp="children">
												{this.state.firstGroupList.map((item) => (
													<Option key={item.FIRST_GROUP_CODE} value={item.FIRST_GROUP_CODE}>
														{item.FIRST_GROUP_NAME}
													</Option>
												))}
											</Select>
										)}
									</Form.Item>
								</>
							) : (
								<>
									<Form.Item label="一级组别名称" className="settingHospitalRequire">
										{getFieldDecorator("firstGroupName", {
											initialValue: rowData?.FIRST_GROUP_NAME,
											rules: [{ required: true, message: "请输入一级组别名称" }]
										})(
											<Input placeholder="请输入一级组别名称" allowClear={true} maxLength={32} style={{ width: 200 }} />
										)}
									</Form.Item>
									{rowData.SECOND_GROUP_CODE ? (
										<Form.Item label="二级组别名称" className="settingHospitalRequire">
											{getFieldDecorator("secondGroupName", {
												initialValue: rowData.SECOND_GROUP_NAME || undefined,
												rules: [{ required: true, message: "请输入二级组别名称" }]
											})(
												<Input
													placeholder="请输入二级组别名称"
													allowClear={true}
													maxLength={32}
													style={{ width: 200 }}
												/>
											)}
										</Form.Item>
									) : null}
								</>
							)}

							<Form.Item label="备 注" className="settingHospitalAddr">
								{getFieldDecorator("remark", {
									initialValue: rowData && rowData.REMARKS ? rowData.REMARKS : ""
								})(<TextArea rows={4} style={{ width: "400px" }} />)}
							</Form.Item>
						</Form>
					</Modal>
				) : null}
			</div>
		);
	}
}

export default Form.create({})(Grouping);
